<div class="advanced-search">
  <h1 class="typography--title u-m-b-16">Credit Report Reasons</h1>
  <div class="advanced-search__form-wrapper">
    <div class="advanced-search__form">
      <form name="schoolSearchForm" aria-label="Search for credit report reasons" novalidate [formGroup]="reasonsForm" (ngSubmit)="onSubmit()">
        <div class="advanced-search__field">
          <label for="fromDate" class="advanced-search__label">From Date</label>
          <div class="advanced-search__input">
            <input type="datetime-local" id="fromDate" formControlName="fromDate" />
          </div>
        </div>
        <div class="advanced-search__field">
          <label for="toDate" class="advanced-search__label">To Date</label>
          <div class="advanced-search__input">
            <input type="datetime-local" id="toDate" formControlName="toDate" />
          </div>
        </div>
        <div class="row align-right">
          <div class="advanced-search__submit btn-group">
            <button type="submit" class="btn btn--elevated btn-group__btn" [disabled]="reasonsForm.invalid">Download</button>
          </div>
        </div>
      </form>
      <div class="full-page-spinner" [class.full-page-spinner--is-active]="(reasonsFiledownloadState$ | async).loading">
        <div class="full-page-spinner__icon"></div>
      </div>
    </div>
  </div>
</div>
